import { z } from "zod";
/**
 * GL ("Sachkonto") accounts an invoice line item can be booked against.
 * Keys match the backend identifiers used by eClaim / claimini-adapter
 */
export const glAccount = {
    TOWING: "TOWING", // Abschleppung
    OLD_PARTS_TAX: "OLD_PARTS_TAX", // Altteile inkl. Steuer
    OLD_PARTS_CLEARING_ACCOUNT: "OLD_PARTS_CLEARING_ACCOUNT", // Altteile Verrechnungskonto
    ASSISTANCE_FLAT_RATE: "ASSISTANCE_FLAT_RATE", // Assistancepauschale
    REFUELING: "REFUELING", // Betankung
    RESOURCES: "RESOURCES", // Betriebsmittel
    FLAT_RATE_FEE: "FLAT_RATE_FEE", // Kostenpauschale
    COST_ESTIMATE: "COST_ESTIMATE", // Kostenvoranschlag
    PREPARATION_OF_REPORTS: "PREPARATION_OF_REPORTS", // Kostenvoranschlag-/Gutachtenerstellung
    RENTAL_CAR: "RENTAL_CAR", // Mietwagen
    EMERGENCY_REPORTS: "EMERGENCY_REPORTS", // Notreparatur
    LAWYER: "LAWYER", // Rechtsanwalt
    REPAIR: "REPAIR", // Reparatur
    EXPERT: "EXPERT", // Sachverständiger
    OTHERS: "OTHERS", // Sonstige
    STAND_COSTS: "STAND_COSTS", // Standkosten
    OVERPASS: "OVERPASS", // Überführung
    ON_SITE_SERVICE: "ON_SITE_SERVICE", // Vor-Ort-Service
};
export const glAccountSchema = z.enum(glAccount);
export const glAccountLabel = {
    TOWING: "Abschleppung",
    OLD_PARTS_TAX: "Altteile inkl. Steuer",
    OLD_PARTS_CLEARING_ACCOUNT: "Altteile Verrechnungskonto",
    ASSISTANCE_FLAT_RATE: "Assistancepauschale",
    REFUELING: "Betankung",
    RESOURCES: "Betriebsmittel",
    FLAT_RATE_FEE: "Kostenpauschale",
    COST_ESTIMATE: "Kostenvoranschlag",
    PREPARATION_OF_REPORTS: "Kostenvoranschlag-/Gutachtenerstellung",
    RENTAL_CAR: "Mietwagen",
    EMERGENCY_REPORTS: "Notreparatur",
    LAWYER: "Rechtsanwalt",
    REPAIR: "Reparatur",
    EXPERT: "Sachverständiger",
    OTHERS: "Sonstige",
    STAND_COSTS: "Standkosten",
    OVERPASS: "Überführung",
    ON_SITE_SERVICE: "Vor-Ort-Service",
};
